export default __webpack_public_path__ + "static/media/johnny.bdf09b2f.png";